import { render, staticRenderFns } from "./TimeTplModify.vue?vue&type=template&id=45a741ab&scoped=true&"
import script from "./TimeTplModify.vue?vue&type=script&lang=js&"
export * from "./TimeTplModify.vue?vue&type=script&lang=js&"
import style0 from "./TimeTplModify.vue?vue&type=style&index=0&id=45a741ab&lang=less&scoped=true&"
import style1 from "./TimeTplModify.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a741ab",
  null
  
)

export default component.exports